import { message } from 'antd';

message.config({
    duration: 2,
});
